import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstStudyReportsViewModalComponent } from './ist-study-reports-view-modal/ist-study-reports-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePickerGlobalOptions } from '../../../constants/service.constants';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-ist-study-reports',
  templateUrl: './ist-study-reports.component.html',
  styleUrls: ['./ist-study-reports.component.scss']
})
export class IstStudyReportsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  studyreportsform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  typeOptions: any[] = [];
  StartDateO: DateObject
  EndDateO: DateObject
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe,

  ) {
  }

  ngOnInit() {

    this.permission = this.commonService.getPagePermission("IST09").toLowerCase();
    this.userType = this.userService.getUserType();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, {});
      modalRef.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Study Reports', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }
    this.studyreportsform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      PatientName: new UntypedFormControl(null),
      SubmittedDateFrom: new UntypedFormControl(null),
      SubmittedDateTo: new UntypedFormControl(null),
      EndDateO : new UntypedFormControl(null),
      StartDateO : new UntypedFormControl(null)

    });

    // if (this.ApplicationID == "" || this.ApplicationID == undefined) {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    // }

    if (this.userType == "E") {
      this.columnDefs = [
        {
          "headerName": "Type",
          "field": "Type",
          "tooltipField": "Type"
        },
        {
          "headerName": "Title",
          "field": "Title",
          "tooltipField": "Title"
        },
        // {
        //   "headerName": "Patient Name (Patient ID)",
        //   "field": "PatientName",
        //   "tooltipField": "PatientName"
        // },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr",
          "tooltipField": "Submitted Date"
        },
        {
          "headerName": "Status",
          "field": "Status",
          "tooltipField": "Status"
        }
      ];
    } else {
      this.columnDefs = [
        {
          "headerName": "Type",
          "field": "Type",
          "tooltipField": "Type"
        },
        {
          "headerName": "Title",
          "field": "Title",
          "tooltipField": "Title"
        },
        // {
        //   "headerName": "Patient Name (Patient ID)",
        //   "field": "PatientName",
        //   "tooltipField": "PatientName"
        // },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr",
          "tooltipField": "Submitted Date"
        }
      ];
    }


    this.tempoperations = [

    ];

    // if (this.permission == "new" && this.userType == "E") {
    //   this.tempoperations.push({
    //     "name": "Add New",
    //     "id": "add"
    //   });
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });
    //   this.tempoperations.push({
    //     "name": "Delete",
    //     "id": "delete"
    //   });
    // }
    // if (this.permission == "edit") {
    //   this.tempoperations.push({
    //     "name": "Edit",
    //     "id": "edit"
    //   });
    // }

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Type",
          "field": "Type",
          "type": "text"
        },
        {
          "label": "Title",
          "field": "Title",
          "type": "text"
        },
        {
          "label": "Patient Name",
          "field": "PatientName",
          "type": "text"
        },
        {
          "label": "Submitted Date (From)",
          "field": "SubmittedDateFrom",
          "type": "date"
        },
        {
          "label": "Submitted Date (End)",
          "field": "SubmittedDateTo",
          "type": "date"
        }
      ]
    };

    // this.operations = this.tempoperations.map(operation => {
    //   return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    // });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      this.commonService.ValidationBanner("Please save General information details to navigate to other forms");
      return false;
    }
    this.GetSummaryData();
    this.GetDropDownsData();

  }

  GetDropDownsData() {
    this.summaryService.masterData("api/ISTStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=").subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
      this.typeOptions = [{ label: "All", value: "", checked: true }].concat(this.typeOptions);
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  // onRowDoubleClicked(event) {
  //   this.modalService.show(IstStudyReportsViewModalComponent, {
  //     backdrop: false,
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: 'modal-llg modal-full-height modal-right',
  //     animated: true,
  //     data: {
  //       heading: 'View',
  //       content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
  //     }
  //   });
  // }

  add() {
    let modalRef = this['self'].modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  edit() {
    let modalRef = this['self'].modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: "Edit",
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this['self'].ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  view() {
    let modalRef = this['self'].modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: "View",
      content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  delete(Service, toastrService) {

    // if (this['self'].userType == "E") {
    if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
      let id = this['self'].selectedRow['ID'];
      let stdyReport = this['self'].selectedRow['Title'];
      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content = { heading: 'Delete Study Report', content: { custommessage: 'Are you sure you want to delete the Study Report   ' + stdyReport + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" } }
      modalRef.result.then(result => {
        if (result == "okclick") {
          Service.DeleteRecord('api/ISTStudyreports/Delete?RecordID=' + id).subscribe(summary => {

            if (summary["Status"] == 0) {
              // toastrService.success("Selected Record(s) has been Deleted");
              this['self'].commonService.SuccessBanner('Study Report ' + stdyReport + ' deleted successfully');
              this['self'].GetSummaryData();
            }
            else {
              toastrService.error("Referenced record Can't be Deleted");

            }
          });
        }
      });

      // }
      // else {
      //   this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
      // }
    }
    else {
      this.commonService.ValidationBanner("Record Can't be deleted");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
    }
  }

  GetSummaryData() {

    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTStudyreports/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  getSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/ISTStudyreports/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add New Study Report",
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add New Study Report",
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  SearchClear() {
    this.studyreportsform.reset();
    //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.studyreportsform.value;
    // if (!this.validateSearch()) {
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["SubmittedDateFrom"] != null && formData["SubmittedDateFrom"] != "" && formData["SubmittedDateFrom"] != 'Invalid Date') {
      formData["StartDateStr"] = this.datepipe.transform(formData["SubmittedDateFrom"], 'dd-MMM-yyyy');
      formData["StartDateO"] = this.Full_Start_Date;
    }
    if (formData["SubmittedDateTo"] != null && formData["SubmittedDateTo"] != "" && formData["SubmittedDateTo"] != 'Invalid Date') {
      formData["EndDateStr"] = this.datepipe.transform(formData["SubmittedDateTo"], 'dd-MMM-yyyy');
      formData["EndDateO"] = this.Full_End_Date;
    }
    formData["SubmittedDateFrom"] = null;
    formData["SubmittedDateTo"] = null;
    this.getSummarySearch(formData);
    // } else {
    //   this.commonService.ValidationBanner("Please enter at least one criteria to perform search" );
    //   // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: "Please enter at least one criteria to perform search" } } });

    // }
  }

  onAdvanceSearchOperation(searchFiletrs) {

  }


  validateSearch() {
    let hasValue: Boolean = true;
    if (this.studyreportsform.controls["SubmittedDateTo"].value != null && this.studyreportsform.controls["SubmittedDateTo"].value != undefined && this.studyreportsform.controls["SubmittedDateTo"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["SubmittedDateFrom"].value != null && this.studyreportsform.controls["SubmittedDateFrom"].value != undefined && this.studyreportsform.controls["SubmittedDateFrom"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Type"].value != null && this.studyreportsform.controls["Type"].value != undefined && this.studyreportsform.controls["Type"].value != "") {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Title"].value != null && this.studyreportsform.controls["Title"].value != undefined && this.studyreportsform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }
  onRowDoubleClicked($event)
  {

  }
}
